import Vue from 'vue';
import Router from 'vue-router';
import AdminLogin from '@/components/AdminLogin'
import Top from '@/components/Top';
import Login from '@/components/Login';
import SelectWork from '@/components/SelectWork';
import SelectPlace from '@/components/SelectPlace';
import SelectStartStop from '@/components/SelectStartStop';
import InputAmount from '@/components/InputAmount';
import Done from '@/components/Done';
import Kitting from '@/components/Kitting';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
    },
    {
      path: '/kitting_start_page',
      name: 'Kitting',
      component: Kitting,
    },
    {
      path: '/admin_login',
      name: 'AdminLogin',
      component: AdminLogin,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/select-place',
      name: 'SelectPlace',
      component: SelectPlace,
    },
    {
      path: '/select-work',
      name: 'SelectWork',
      component: SelectWork,
    },
    {
      path: '/select-startstop',
      name: 'SelectStartStop',
      component: SelectStartStop,
    },
    {
      path: '/input_amount',
      name: 'InputAmount',
      component: InputAmount,
    },
    {
      path: '/done',
      name: 'Done',
      component: Done,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js